import * as React from 'react'

import { UserIcon, UsersIcon } from 'lucide-react'
import { classList } from 'react-classlist-helper'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import AvatarType from '../../enums/AvatarType'

import './Avatar.scss'

interface IProps {
  src?: string
  size?: AvatarSize
  initials?: string
  className?: string
  avatarType?: AvatarType
  isOnline?: boolean
}

// translated

export enum AvatarSize {
  Enormous = 'enormous',
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  Tiny = 'tiny',
  Minuscule = 'minuscule',
  XMinuscule = 'x-minuscule',
}

export default class Avatar extends React.PureComponent<IProps> {
  public static defaultProps = {
    size: AvatarSize.Small,
  }

  public render() {
    const { src, size, initials, className, isOnline = null } = this.props

    return (
      <div
        className={classList({
          'avatar-container row x-center br-rounded no-flex relative': true,
          'initials-wrapper': !src && !!initials,
          [size]: true,
          [className]: !!className,
        })}
      >
        {this.renderImg()}
        {isOnline != null && (
          <span
            className={classList({
              'avatar-status': true,
              online: isOnline,
            })}
          />
        )}
      </div>
    )
  }

  private renderImg(): JSX.Element {
    const { src, initials, avatarType } = this.props
    const { avatar } = Localization.translator

    if (src) {
      return <img src={src} alt={avatar} />
    }
    if (initials) {
      return this.renderInitials(initials)
    }

    switch (avatarType) {
      case AvatarType.User:
        return (
          <UserIcon className="tw:size-[60%] tw:flex-none! tw:self-center tw:text-muted-foreground" />
        )

      case AvatarType.Company:
        return (
          <UsersIcon className="tw:size-[60%] tw:flex-none! tw:self-center tw:text-muted-foreground" />
        )

      default:
        return (
          <UserIcon className="tw:size-[60%] tw:flex-none! tw:self-center tw:text-muted-foreground" />
        )
    }
  }

  private renderInitials(initials: string): JSX.Element {
    return (
      <div className="text bold no-grow no-select initials">{initials}</div>
    )
  }
}
